/**
 * Get available installment values for specific card brand and order total.
 *
 * @param {string} brand card brand code
 * @param {double} orderTotal order total value
 * @returns {array}
 */
function getInstallmentValues(brand, orderTotal) {
  const brandValues = window.AdyenInstallmentsOptions[brand];
  if (typeof brandValues === 'undefined') {
    return null;
  }
  const minTotals = Object.keys(brandValues).sort((a, b) => {
    const keyA = parseInt(a, 10);
    const keyB = parseInt(b, 10);
    if (Number.isNaN(keyA)) {
      return 1;
    }
    if (Number.isNaN(keyB)) {
      return -1;
    }
    return keyA < keyB ? 1 : -1;
  });
  let selectedBrandValuesKey;
  minTotals.every((minTotal) => {
    if (orderTotal >= Number.parseInt(minTotal, 10)) {
      selectedBrandValuesKey = minTotal;
      return false;
    }
    return true;
  });
  if (!selectedBrandValuesKey) {
    return null;
  }
  return brandValues[selectedBrandValuesKey];
}

/**
 * Update installment selector options for specific brand and order total value
 *
 * @param {Element} installmentsContainer container in which we should update available options
 * @param {string} brand card brand code
 * @param {double} orderTotal order total value
 * @returns {array}
 */
function updateInstallmentSelectorOptions(
  installmentsContainer,
  brand,
  orderTotal
) {
  if (!window.AdyenInstallmentsEnabled || !window.AdyenInstallmentsOptions) {
    return;
  }

  const installmentsSelector = installmentsContainer.querySelector('select');
  const installmentValues = getInstallmentValues(brand, orderTotal);

  if (installmentValues && installmentValues.length) {
    // eslint-disable-next-line no-param-reassign
    installmentsSelector.innerHTML = '';

    const installmentOptionEmpty = document.createElement('option');
    installmentOptionEmpty.style = 'display:none';
    installmentOptionEmpty.selected = 'selected';
    installmentOptionEmpty.disabled = true;
    installmentOptionEmpty.value = '';
    installmentOptionEmpty.text = '';
    installmentsSelector.append(installmentOptionEmpty);

    installmentValues.forEach((installmentValue) => {
      const installmentOption = document.createElement('option');
      installmentOption.value = installmentValue;
      if (installmentValue === 1) {
        installmentOption.text = window.installmentsOptionLabelSingular;
      } else {
        installmentOption.text =
          window.installmentsOptionLabelMonthsPlural.replace(
            '{0}',
            installmentValue
          );
      }
      installmentsSelector.append(installmentOption);
      installmentsContainer.classList.remove('d-none');
    });
  } else {
    installmentsContainer.classList.add('d-none');
  }
}

/**
 * Update all dynamic saved card installment options.
 * Call this function whenever order total is modified.
 */
function updateInstallmentOptions() {
  if (!window.AdyenInstallmentsEnabled || !window.AdyenInstallmentsOptions) {
    return;
  }
  const savedCardContainers = document.querySelectorAll(
    '.adyen-payment-method-type[data-is-stored="true"]'
  );
  savedCardContainers.forEach((li) => {
    const installmentsContainer = li.querySelector(
      '.adyen-checkout__custominstallments'
    );
    const storedCardInput = li.querySelector('input');
    const storedCardBrand = storedCardInput.getAttribute('data-brand');
    const orderTotal = Number.parseFloat(
      document
        .querySelector('.grand-total-container .grand-total')
        .getAttribute('data-value')
    );
    updateInstallmentSelectorOptions(
      installmentsContainer,
      storedCardBrand,
      orderTotal
    );
  });
}

module.exports = {
  getInstallmentValues,
  updateInstallmentSelectorOptions,
  updateInstallmentOptions,
};
